import { motion, useReducedMotion } from "framer-motion";

const ProblemStatement = () => {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay: number) =>
    prefersReducedMotion
      ? {}
      : {
          initial: { opacity: 0, y: 20 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true },
          transition: { duration: 0.6, ease: "easeOut" as const, delay },
        };

  return (
    <section className="bg-background px-6 py-20 md:py-28">
      <div className="mx-auto max-w-[640px] text-center">
        <motion.span
          className="mb-4 inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent"
          {...fadeUp(0)}
        >
          Why Circle Exists
        </motion.span>

        <motion.h2
          className="mb-12 font-serif text-3xl font-semibold leading-tight text-foreground md:text-4xl"
          {...fadeUp(0.1)}
        >
          You care deeply. You just keep forgetting to show it.
        </motion.h2>

        <motion.p
          className="mb-6 text-base leading-relaxed text-muted-foreground"
          {...fadeUp(0.2)}
        >
          You meant to call on their birthday. You meant to reach out after the
          hard news. You meant to send something when they got the promotion.
        </motion.p>

        <motion.p
          className="mb-6 text-base leading-relaxed text-muted-foreground"
          {...fadeUp(0.6)}
        >
          You didn't forget because you don't care.
        </motion.p>

        <motion.p
          className="mb-10 text-base leading-relaxed text-muted-foreground"
          {...fadeUp(1.0)}
        >
          You forgot because life is full, memory is imperfect, and the people
          who matter most somehow get pushed behind the urgent things.
        </motion.p>

        <motion.p
          className="font-serif text-lg italic text-accent md:text-xl"
          {...fadeUp(1.6)}
        >
          Circle exists because caring about someone in your heart means nothing
          if they never feel it.
        </motion.p>
      </div>
    </section>
  );
};

export default ProblemStatement;
